import gql from 'graphql-tag';

export const MarketingMaterialAssetDetails = gql`
  fragment MarketingMaterialAssetDetails on MarketingMaterialAsset {
    id
    name
    marketing_material_type
    asset_image {
      id
      url
    }
  }
`;
